
import http from '@/features/shared/http/client';
import { AIShotGenerationOptions, Shot } from '@storyverse/shared';

export async function generateShotListAI(options: AIShotGenerationOptions): Promise<Shot[]> {
    console.log('Generating shot list using Cloud Function for scene content length:', options.sceneContent?.length ?? 0)
    console.log('With options:', options)
    try {
        console.log('Calling Cloud Function (REST) via Axios...')

        const response = await http.post<Shot[]>('/generateShotListAI', { options })

        console.log('Cloud Function Response Received')

        return response.data
    } catch (e: any) {
        console.error('Error generating shot list via Cloud Function:', e)
        // Log detailed error info if available
        if (e.message) console.error('Error message:', e.message)
        if (e.code) console.error('Error code:', e.code)
        if (e.details) console.error('Error details:', e.details)
        throw e
    }
}
